import React, { Component } from "react";
import autoBind from "auto-bind";
import { connect } from "react-redux";

import {
  ssUpdateActiveQuery,
  ssUpdateMailingListID,
  ssUpdateAllOrganizations,
  ssSubmitQuery,
} from "../../../../actions/subscriber_search.js";

import Select2 from "../../../widgets/select2.jsx";

class SubscriberSearchBar extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    if (props.activeQuery !== "") {
      this.props.dispatch(ssSubmitQuery(false));
    }
  }

  detectEnterKey(e) {
    if (e.key === "Enter") {
      this.submit();
    }
  }

  handleQueryUpdate(e) {
    this.props.dispatch(ssUpdateActiveQuery(e.target.value));
  }

  handleMailingListUpdate(mailingListID) {
    this.props.dispatch(ssUpdateMailingListID(parseInt(mailingListID, 0)));
  }

  submit() {
    // Do a simple check to prevent misfires
    this.props.dispatch(ssSubmitQuery(true));
  }

  render() {
    let mailingListOptions = this.props.mailingLists.map((mailingList) => {
      return { value: mailingList.id, label: mailingList.name };
    });
    let selectOptions = [
      { value: 0, label: "All Mailing Lists" },
      ...mailingListOptions,
    ];
    let placeholderText = selectOptions.filter((option) => {
      return option.value === this.props.mailingListID;
    })[0].label;

    return (
      <div className="clearfix subscriber-search-bar">
        <div className="pull-right">
          <button className="button" onClick={this.submit}>
            {t("buttons.submit")}
          </button>
        </div>
        <ul className="form-fields">
          <li className="form-field clear string field_with_hint grin">
            <label className="string control-label">
              {I18n.t("standard_fields.email")}
            </label>
            <input
              type="text"
              onChange={this.handleQueryUpdate}
              value={this.props.activeQuery}
              className="string"
              onKeyDown={this.detectEnterKey}
            />
          </li>

          {this.props.showAllOrganizationsOption && (
            <li className="form-field clear radio_buttons optional">
              <label className="radio_buttons optional control-label">
                {I18n.t("phrases.all_organizations")}
              </label>
              <label className="radio">
                <input
                  className="radio_buttons"
                  type="radio"
                  checked={this.props.allOrganizations}
                  onChange={() =>
                    this.props.dispatch(ssUpdateAllOrganizations(true))
                  }
                />
                {I18n.t("phrases.yes")}
              </label>
              <label className="radio">
                <input
                  className="radio_buttons"
                  type="radio"
                  checked={!this.props.allOrganizations}
                  onChange={() =>
                    this.props.dispatch(ssUpdateAllOrganizations(false))
                  }
                />
                {I18n.t("phrases.no")}
              </label>
            </li>
          )}

          {!this.props.allOrganizations && (
            <li className="form-field clear string field_with_hint grin">
              <label className="string control-label">
                {I18n.t("phrases.mailing_list")}
              </label>
              <Select2
                value={this.props.mailingListID}
                options={selectOptions}
                onChange={this.handleMailingListUpdate}
                placeholder={placeholderText}
                className="ss-mailing-list-selector"
                isSearchable
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  initialQuery: state.query,
  activeQuery: state.activeQuery,
  mailingLists: state.mailingLists,
  mailingListID: state.mailingListID,
  allOrganizations: state.allOrganizations,
  showAllOrganizationsOption: state.showAllOrganizationsOption,
});

export default connect(mapStateToProps)(SubscriberSearchBar);
